import { AppAction, PageFilter } from '../app';
import {
  SampleDevelopmentWlApprovalRequest,
  SampleDevelopmentWlApprovalRequestListFilter,
} from './sampleDevelopmentWlApprovalRequest.types';

export const FETCH_SAMPLE_DEV_WL_APPROVAL_REQUEST_LIST =
  'FETCH_SAMPLE_DEV_WL_APPROVAL_REQUEST_LIST';
export const OPEN_SAMPLE_DEV_WL_APPROVAL_REQUEST_DIALOG =
  'OPEN_SAMPLE_DEV_WL_APPROVAL_REQUEST_DIALOG';

export const CLOSE_SAMPLE_DEV_WL_APPROVAL_REQUEST_DIALOG =
  'CLOSE_SAMPLE_DEV_WL_APPROVAL_REQUEST_DIALOG';

export const UPDATE_SAMPLE_DEV_WL_APPROVAL_REQUEST_RESPONSE =
  'UPDATE_SAMPLE_DEV_WL_APPROVAL_REQUEST_RESPONSE';
export const fetchSampleDevelopmentWlApprovalRequestList = (
  filters: SampleDevelopmentWlApprovalRequestListFilter,
  paging: PageFilter,
): AppAction => {
  return {
    type: FETCH_SAMPLE_DEV_WL_APPROVAL_REQUEST_LIST,
    payload: {
      filters,
      paging,
    },
  };
};

export const updateSampleDevelopmentWlApprovalRequestResponse = (
  payload: SampleDevelopmentWlApprovalRequest,
) => ({
  type: UPDATE_SAMPLE_DEV_WL_APPROVAL_REQUEST_RESPONSE,
  payload,
});

export const openSampleDevelopmentWlApprovalRequestDialog = () => ({
  type: OPEN_SAMPLE_DEV_WL_APPROVAL_REQUEST_DIALOG,
});

export const closeSampleDevelopmentWlApprovalRequestDialog = () => ({
  type: CLOSE_SAMPLE_DEV_WL_APPROVAL_REQUEST_DIALOG,
});
